module.exports = __webpack_public_path__ + "img/kep1.33566d9e.jpg";